import React, { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { PieChart, Pie, Cell } from "recharts";
import TableHeader from "./lib/TableHeader";
import {
  getAgentDetails,
  getPortfolioDetails,
} from "../../../../store/actions";
import { Divider, Grid } from "@material-ui/core";

const BUILD_URL = process.env.PUBLIC_URL;

const ListLabels = {
  fontSize: "14px",
  fontWeight: "400",
  color: "#666666",
  marginBottom: "0.5rem",
};

const ListValues = {
  fontSize: "14px",
  fontWeight: "400",
  color: "#111111",
};

const Portfolio = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const token = useSelector((state) => state.authReducer.token);
  const subscriber = useSelector((state) => state.newSubscriber.subscriberData);
  const { PAN } = useSelector((state) => state.profileReducer.profileData);
  const [agentRefNumber, setAgentRefNumber] = useState("");
  const [agentData, setAgentData] = useState("");
  const [portfolioData, setPortfolioData] = useState("");

  useEffect(() => {
    const arn = token.replace("ARN-", "");
    const diff = 8 - arn.length;
    const pad = "0".repeat(diff);
    setAgentRefNumber(PAN + pad + arn);
  }, []);

  useEffect(() => {
    async function fetchData() {
      const response = await dispatch(
        getAgentDetails({
          agentRefNumber: agentRefNumber,
        })
      );
      setAgentData(response?.data);
    }

    if (agentRefNumber) {
      fetchData();
    }
  }, [agentRefNumber]);

  useEffect(() => {
    if (agentData?.POPCode) {
      fetchPortfolioData();
    }
  }, [agentData]);

  const fetchPortfolioData = async (amount) => {
    const params = {
      // PRAN: "400070056982",
      PRAN: subscriber?.PRAN,
      POP_Code: agentData?.POPCode,
      POP_SP_Code: agentData?.POP_SPCode,
      AccountType: subscriber?.AccountType,
    };
    const response = await dispatch(getPortfolioDetails(params));
    if (response?.statusCode == "10000") {
      setPortfolioData(response?.data);
    } else {
      alert(response?.message);
    }
  };

  const Section = ({ title, description }) => {
    return (
      <Grid xs={3}>
        <p style={ListLabels}>{title}</p>
        <p style={ListValues}>{description}</p>
      </Grid>
    );
  };

  return (
    <div className="container-margin" style={{ marginTop: "3%" }}>
      <div className="portfolio-card">
        <Grid container spacing={1}>
          <Grid xs={4} style={{ display: "flex" }}>
            <div style={{ padding: "20px 30px", display: "flex" }}>
              <img
                alt="portfolioProfileIcon"
                src={`${BUILD_URL}/images/portfolioProfileIcon.svg`}
                width="62"
                height="62"
                className="user-icon"
              />
              <div style={{ marginLeft: "1rem" }}>
                <div
                  style={{
                    fontSize: "20px",
                    color: "#003D7B",
                    fontWeight: "400",
                  }}
                >
                  {subscriber?.SubscriberName}
                </div>
                <div
                  style={{
                    fontSize: "16px",
                    color: "#696969",
                    fontWeight: "400",
                  }}
                >
                  <img
                    alt="panCardIcon"
                    src={`${BUILD_URL}/images/panCardIcon.svg`}
                    width="22"
                    height="22"
                    className="user-icon"
                  />
                  PRAN:{subscriber?.PRAN}
                </div>
                <div
                  style={{
                    display: "flex",
                    background: "#F5F6FB",
                    width: "fit-content",
                    padding: "8px 12px",
                    borderRadius: "25px",
                    margin: "10px 8px",
                  }}
                >
                  <div style={{ fontSize: "12px", marginRight: "8px" }}>
                    <img
                      alt="portfolioTicIcon"
                      src={`${BUILD_URL}/images/portfolioTicIcon.svg`}
                      width="14"
                      height="14"
                      className="user-icon"
                    />
                    TIER I
                  </div>
                  {portfolioData?.["Tier-2-Schemes"]?.length ? (
                    <div style={{ fontSize: "12px" }}>
                      {" "}
                      <img
                        alt="portfolioTicIcon"
                        src={`${BUILD_URL}/images/portfolioTicIcon.svg`}
                        width="14"
                        height="14"
                        className="user-icon"
                      />
                      TIER II
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          </Grid>

          <Grid xs={4} style={{ display: "flex" }}>
            <Divider orientation="vertical" />
            <div style={{ padding: "20px 20px" }}>
              <div style={{ display: "flex" }}>
                <img
                  alt="totalContrbutionAmount"
                  src={`${BUILD_URL}/images/totalContrbutionAmount.svg`}
                  width="40"
                  height="40"
                  className="user-icon"
                />
                <div style={{ marginLeft: "1rem" }}>
                  <p
                    style={{
                      marginBottom: "0px",
                      color: "#565863",
                      fontSize: "13px",
                    }}
                  >
                    Total Contribution Amount
                  </p>
                  <p
                    style={{
                      color: "#334FA5",
                      fontSize: "18px",
                    }}
                  >
                    &#8377;
                    {portfolioData?.totalContributionAmount?.toLocaleString(
                      "en-IN"
                    )}{" "}
                  </p>
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <img
                  alt="totalCurrentValuation"
                  src={`${BUILD_URL}/images/totalCurrentValuation.svg`}
                  width="40"
                  height="40"
                  className="user-icon"
                />
                <div style={{ marginLeft: "1rem" }}>
                  <p
                    style={{
                      marginBottom: "0px",
                      color: "#565863",
                      fontSize: "13px",
                    }}
                  >
                    Total Current Valuation
                  </p>
                  <p
                    style={{
                      color: "#334FA5",
                      fontSize: "18px",
                    }}
                  >
                    &#8377;
                    {portfolioData?.totalCurrentValuation?.toLocaleString(
                      "en-IN"
                    )}{" "}
                  </p>
                </div>
              </div>
            </div>
          </Grid>

          <Grid xs={4} style={{ display: "flex" }}>
            <Divider orientation="vertical" />
            <div style={{ display: "flex" }}>
              <PieChart width={150} height={150}>
                <Pie
                  fill="#8884d8"
                  data={[
                    {
                      name: "Tier I",
                      value: portfolioData?.tier1Total,
                    },
                    {
                      name: "Tier II",
                      value: portfolioData?.tier2Total,
                    },
                  ]}
                  dataKey="value"
                  nameKey="name"
                  innerRadius={40}
                  outerRadius={50}
                >
                  <Cell name={"Tier I"} key={1} fill={`#0072BC`} />
                  <Cell name={"Tier II"} key={2} fill={`#c1d8e6`} />
                </Pie>
              </PieChart>
              <div className="nps-pie-chart-map2">
                <div className="d-flex " key={1}>
                  <div
                    style={{
                      backgroundColor: "#0072BC",
                      height: 10,
                      marginTop: 4,
                      width: 10,
                      padding: 4,
                    }}
                  />
                  <span>
                    Tier I - &#8377;
                    {portfolioData?.tier1Total?.toLocaleString("en-IN")}
                  </span>
                </div>
                <div className="d-flex " key={2} style={{ marginTop: "0px" }}>
                  <div
                    style={{
                      backgroundColor: `#c1d8e6`,
                      height: 10,
                      marginTop: 4,
                      width: 10,
                      padding: 5,
                    }}
                  />
                  <span>
                    Tier II - &#8377;
                    {portfolioData?.tier2Total?.toLocaleString("en-IN")}
                  </span>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
      <div className="sub-table-container" style={{ padding: "32px 12px" }}>
        <div className="sub-table-tab-container2">
          <div
            className="sub-table-tab-container"
            style={{ borderBottom: "0px" }}
          >
            <TableHeader value="Investment" active={true} />
          </div>
        </div>
      </div>
      <div className="portfolio-list-card">
        {portfolioData?.["Tier-1-Schemes"]?.map((item) => (
          <div style={{ padding: "12px 30px" }}>
            <p
              style={{ fontSize: "14px", fontWeight: "400", color: "#111111" }}
            >
              {item.FundName}
            </p>
            <Grid container spacing={1} style={{ paddingLeft: "8px" }}>
              <Section
                title={"Cost Value"}
                description={
                  <>&#8377;{item.InvestedAmount?.toLocaleString("en-IN")}</>
                }
              />
              <Section
                title={"Current Value"}
                description={
                  <>&#8377;{item.CurrentAmount?.toLocaleString("en-IN")}</>
                }
              />
              <Section
                title={"Appreciation"}
                description={
                  <>
                    {item.appreciationRate}%{" "}
                    {parseFloat(item.appreciationRate) > 0 ? (
                      <img
                        alt="totalCurrentValuation"
                        src={`${BUILD_URL}/images/portfolioPositive.svg`}
                        width="16"
                        height="20"
                        className="user-icon"
                        style={{ marginBottom: "5px" }}
                      />
                    ) : (
                      <img
                        alt="portfolioNegative"
                        src={`${BUILD_URL}/images/portfolioNegative.svg`}
                        width="16"
                        height="20"
                        className="user-icon"
                        style={{ marginBottom: "5px" }}
                      />
                    )}
                  </>
                }
              />
              <Section title={"Tier"} description={`TIER I`} />
            </Grid>
            <Divider />
          </div>
        ))}
        {portfolioData?.["Tier-2-Schemes"]?.map((item) => (
          <div style={{ padding: "12px 30px" }}>
            <p
              style={{ fontSize: "14px", fontWeight: "400", color: "#111111" }}
            >
              {item.FundName}
            </p>
            <Grid container spacing={1} style={{ paddingLeft: "8px" }}>
              <Section
                title={"Cost Value"}
                description={
                  <>&#8377;{item.InvestedAmount?.toLocaleString("en-IN")}</>
                }
              />
              <Section
                title={"Current Value"}
                description={
                  <>&#8377;{item.CurrentAmount?.toLocaleString("en-IN")}</>
                }
              />
              <Section
                title={"Appreciation"}
                description={
                  <>
                    {item.appreciationRate}%{" "}
                    {parseFloat(item.appreciationRate) > 0 ? (
                      <img
                        alt="totalCurrentValuation"
                        src={`${BUILD_URL}/images/portfolioPositive.svg`}
                        width="16"
                        height="20"
                        className="user-icon"
                        style={{ marginBottom: "5px" }}
                      />
                    ) : (
                      <img
                        alt="portfolioNegative"
                        src={`${BUILD_URL}/images/portfolioNegative.svg`}
                        width="16"
                        height="20"
                        className="user-icon"
                        style={{ marginBottom: "5px" }}
                      />
                    )}
                  </>
                }
              />
              <Section title={"Tier"} description={`TIER II`} />
            </Grid>
            <Divider />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Portfolio;
